<button
  mat-icon-button
  aria-label="notes"
  matTooltip="{{ 'notes' | translate }}">
  @if (hasCount) {
    <mat-icon>sticky_note_2</mat-icon>
  } @else {
    <span class="material-symbols-outlined">note_add</span>
  }
</button>
